// Default state
export const DEFAULT_STATE = {
  isFetching: true,
  isError: false,
  response: {},
};
export const DEFAULT_STATE_FF_EF = {
  isFetching: false,
  isError: false,
  response: {},
};
export const DEFAULT_STATE_FF_ET = {
  isFetching: false,
  isError: true,
  response: {},
};

// redux state to toggle menu items
export const sidebarToggleItems = {
  users: false,
  bookings: false,
  operatorTrips: false,
  drivers: false,
  customers: false,
  taxidaUsers: false,
  invoice: false,
  fare: false,
  operators: false,
  b2b: false,
  enterprise: false,
};

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const priceTypes = {
  1: "Flat",
  2: "Percentage",
};
export const paymentPercentage = [
  { label: "Full", value: 100 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
  { label: "60%", value: 60 },
  { label: "70%", value: 70 },
  { label: "80%", value: 80 },
  { label: "90%", value: 90 },
  { label: "Cash", value: 0 },
  // { label: "Account", value: "account" },
];
export const paymentTypeList = [
  { label: "Cash", value: 0 },
  { label: "Account", value: "account" },
];
export const advancePercentage = 10;

export const bookingType = {
  bookRide: "One way",
  round: "Round trip",
  multiCity: "Multi-city",
  package: "Package",
};
export const cancelledBy = [
  {
    label: "Select",
    value: "",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Operator",
    value: "operator",
  },
  { label: "Admin", value: "admin" },
];

export const cancelledReason = [
  {
    label: "Select",
    value: "",
  },
  {
    label: "Plan change",
    value: "Plan change",
  },
  {
    label: "Unable to contact the driver",
    value: "Unable to contact the driver",
  },
  { label: "Driver denied", value: "Driver denied" },
  { label: "Got a better price", value: "Got a better price" },
  { label: "Unable to contact Taxida", value: "Unable to contact Taxida" },
];

export const bookingTypeFilter = {
  oneWay: "One way",
  roundTrip: "Round trip",
  multiCity: "Multicity",
  package: "Package",
};

export const ondcBookingTypeFilter = {
  local: "Local",
  "hourly-rental": "Hourly rental",
};
export const multicityDuration = [
  { label: "00:30", value: 30 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "03:30", value: 210 },
  { label: "04:00", value: 240 },
  { label: "04:30", value: 270 },
  { label: "05:00", value: 300 },
  { label: "05:30", value: 330 },
  { label: "06:00", value: 360 },
];
export const packageDuration = [
  { label: "Select", value: 0 },
  { label: "2 hrs", value: 120 },
  { label: "3 hrs", value: 180 },
  { label: "4 hrs", value: 240 },
  { label: "5 hrs", value: 300 },
  { label: "6 hrs", value: 360 },
  { label: "7 hrs", value: 420 },
  { label: "8 hrs", value: 480 },
  { label: "9 hrs", value: 540 },
  { label: "10 hrs", value: 600 },
  { label: "11 hrs", value: 660 },
  { label: "12 hrs", value: 720 },
  { label: "1 days", value: 1440 },
  { label: "2 days", value: 2880 },
  { label: "3 days", value: 4320 },
  { label: "4 days", value: 5760 },
  { label: "5 days", value: 7200 },
  { label: "6 days", value: 8640 },
  { label: "7 days", value: 10800 },
  { label: "8 days", value: 11520 },
  { label: "9 days", value: 12960 },
  { label: "10 days", value: 14400 },
];
export const garageDistanceLimit = [
  { label: "No limit", value: 0 },
  { label: "1 Km", value: 1 },
  { label: "2 Km", value: 2 },
  { label: "3 Km", value: 3 },
  { label: "4 Km", value: 4 },
  { label: "5 Km", value: 5 },
  { label: "6 Km", value: 6 },
  { label: "7 Km", value: 7 },
  { label: "8 Km", value: 8 },
  { label: "9 Km", value: 9 },
  { label: "10 Km", value: 10 },
  { label: "11 Km", value: 11 },
  { label: "12 Km", value: 12 },
  { label: "13 Km", value: 13 },
  { label: "14 Km", value: 14 },
  { label: "15 Km", value: 15 },
  { label: "16 Km", value: 16 },
  { label: "17 Km", value: 17 },
  { label: "18 Km", value: 18 },
  { label: "19 Km", value: 19 },
  { label: "20 Km", value: 20 },
  { label: "21 Km", value: 21 },
  { label: "22 Km", value: 22 },
  { label: "23 Km", value: 23 },
  { label: "24 Km", value: 24 },
  { label: "25 Km", value: 25 },
  { label: "26 Km", value: 26 },
  { label: "27 Km", value: 27 },
  { label: "28 Km", value: 28 },
  { label: "29 Km", value: 29 },
  { label: "30 Km", value: 30 },
  { label: "31 Km", value: 31 },
  { label: "32 Km", value: 32 },
  { label: "33 Km", value: 33 },
  { label: "34 Km", value: 34 },
  { label: "35 Km", value: 35 },
];
export const subscriptionTypes = {
  subscription: "Subscription",
  perRide: "Per ride",
};
export const bidExpiryType = {
  fromNow: "From now",
  beforePickup: "Before pickup time",
};

export const loginType = {
  1: "Admin",
  3: "Controller",
};

export const TIME_FORMAT_TO_SHOW = "HH:mm A";
export const DATE_FORMAT_TO_SHOW = "DD-MM-YYYY";

export const ONDC_DATE_FORMAT_TO_SHOW = "YYYY-MM-DD";

export const subscriptionPriceTypes = {
  subscription: {
    bucket: "Bucket",
    flat: "Flat",
  },
  perRide: {
    flat: "Flat",
    percentage: "Percentage",
  },
};
export const rideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop",
};

export const operatingRideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop",
};

export const operatingTripTypes = {
  outstation: "Outstation",
  local: "Local",
};

export const bookingStatus = {
  1: "Pending",
  // 2: "Accepted", // there is no accepted status for now
  3: "Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Arrived",
  8: "On Trip",
  9: "Cancelled",
  10: "Completed",
  11: "On Bid",
};

export const b2bBookingStatus = {
  1: "Pending",
  2: "Operator Assigned",
  3: "Driver Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Driver Arrived",
  8: "Empty Trip",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
};
export const sellerStatus = {
  5: "Confirm",
  6: "Broadcasted",
  7: "Driver Assigned",
  8: "Driver Accepted",
  9: "En Route To Pickup",
  10: "Driver Arrived",
  11: "On Trip",
  12: "Completed",
  13: "Cancelled",
  14: "Customer no show",
  15: "Invoiced",
  16: "Rejected",
};

export const sellerEnquiryList = {
  2: "Search",
  3: "Select",
  4: "Init",
  5: "Confirm",
  16: "Rejected",
};

export const mmtReportStatus = {
  1: "Pending for operator assign",
  2: "Operator Assigned",
  3: "Driver Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Driver Arrived",
  8: "On trip-Empty",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
  12: "Pending for approval",
  13: "Queued",
  14: "Fare requested",
  15: "Taxida verified",
  16: "Invoiced",
  17: "Customer no show",
};

export const etsBookingStatus = {
  1: "Queued",
  2: "Pending for Operator Assigned",
  3: "Operator Assigned",
  4: "Driver Assigned",
  5: "Driver Rejected",
  6: "Driver Accepted",
  7: "En Route To Pickup",
  8: "Driver Arrived",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
};

export const etsTripType = {
  "Home pickup": "Home pickup",
  "Office pickup": "Office pickup",
};

// export const etsBookingStatus = [
//   {
//     label: "Queued",
//     value: 1,
//   },
//   {
//     label: "Pending for Operator Assigned",
//     value: 2,
//   },
//   {
//     label: "Operator Assigned",
//     value: 3,
//   },
//   {
//     label: "Driver Assigned",
//     value: 4,
//   },
// ];

export const tripTypeStatus = {
  1: "One way",
  2: "Round trip",
  3: "Multicity",
  4: "Package",
};

export const operatorBookingStatus = {
  1: "Pending",
  2: "On Bid",
  3: "Responded",
  4: "Assigned",
};

export const bgColors = {
  1: "bg-lred",
  2: "bg-yellow",
  3: "bg-grn",
  4: "bg-grey",
  5: "bg-dred",
  6: "bg-blu",
  7: "bg-yellow",
  8: "bg-lgrn",
  9: "bg-lgrey",
  10: "bg-sail",
  11: "bg-yellow",
  14: "bg-grey",
  15: "bg-teal",
  16: "bg-lav",
  17: "bg-mauve",
  18: "bg-go",
  19: "bg-stop",
  20: "bg-again",
  21: "bg-eryellow",
  22: "bg-astrosnavy",
};

export const bgStatusColors = {
  "Pending for operator assign": "bg-lred",
  "Operator Assigned": "bg-yellow",
  "Driver Assigned": "bg-grn",
  "Driver Accepted": "bg-grey",
  "Driver Rejected": "bg-dred",
  "En Route To Pickup": "bg-blu",
  "Driver Arrived": "bg-yellow",
  "On trip-Empty": "bg-lgrn",
  "On Trip": "bg-lgrey",
  Completed: "bg-sail",
  Cancelled: "bg-yellow",
  "Fare requested": "bg-grey",
  "Taxida verified": "bg-teal",
  Invoiced: "bg-lav",
  "Customer no show": "bg-mauve",
  Broadcasted: "bg-go",
  Revoked: "bg-stop",
  "Re-Broadcasted": "bg-again",
  "Pending for business assign": "bg-eryellow",
  "Not confirmed by taxida": "bg-astrosnavy",
  "Vendor Assigned": "bg-teal",
  ENQUIRY_REQUESTED: "bg-grey",
  FARE_SUBMITTED: "bg-yellow",
  INVENTORY_BLOCKED: "bg-blu",
  BOOKING_CONFIRMED: "bg-grn",
  ENQUIRY_REJECTED: "bg-dred",
  // "Pending for operator assign": "bg-s-yellow",
  // "Operator Assigned": "bg-s-lemon",
  // "Driver Assigned": "bg-s-lyellow",
  // "Driver Accepted": "bg-s-green",
  // "Driver Rejected": "bg-s-Peach",
  // "En Route To Pickup": "bg-s-blue",
  // "Driver Arrived": "bg-s-sblue",
  // "On trip-Empty": "bg-s-violet",
  // "On Trip": "bg-s-mblue",
  // "Completed": "bg-s-limegreen",
  // "Cancelled": "bg-s-vibrantpink",
  // "Pending for approval": "bg-s-lightsalmon",
  // "Queued": "bg-s-almondfrost",
  // "Fare requested": "bg-s-Mindaro",
  // "Taxida verified": "bg-s-PastelBlue",
  // "Invoiced": "bg-s-TintedMagenta",
  // "Customer no show": "bg-s-softred",
  // "Broadcasted": "bg-s-Purple",
  // "Revoked": "bg-s-gray",
  // "Re-Broadcasted": "bg-s-LightCyan",
  // "Pending for business assign": "bg-s-PaleOrange",
  // "Not confirmed by taxida": "bg-s-RedOrange"
};
export const statusLabels = {
  ENQUIRY_REQUESTED: "Enquiry Requested",
  FARE_SUBMITTED: "Fare Submitted",
  INVENTORY_BLOCKED: "Inventory Blocked",
  BOOKING_CONFIRMED: "Booking Confirmed",
  ENQUIRY_REJECTED: "Enquiry Rejected",
};

export const statusColors = {
  1: "bg-lred",
  2: "bg-yellow",
  3: "bg-grn",
  4: "bg-grey",
  5: "bg-blu",
  6: "bg-teal",
  7: "bg-grn",
  8: "bg-grey",
  9: "bg-yellow",
  11: "bg-sail",
  12: "bg-lgrn",
  13: "bg-dred",
  14: "bg-lav",
  16: "bg-lred",
};
// user Roles and its labels
export const userRoles = {
  1: "admin",
  2: "subAdmin",
  3: "controller",
  4: "affiliateAgent",
  5: "aggregator",
  6: "businessUser",
  7: "driver",
  8: "customer",
  9: "driverManager",
};
export const userRoleLabels = {
  1: "Admin",
  2: "Sub-admin",
  3: "Controller",
  4: "Affiliate agent",
  5: "Aggregator",
  6: "Business User",
  7: "Driver",
  8: "Customer",
  9: "Driver manager",
};
export const tripType = [
  {
    label: "Point to Point",
    value: "bookRide",
  },
  // {
  //   label: "Multi stop",
  //   value: "multiCity",
  // },
  { label: "Hourly rental", value: "package" },
];

export const newTripType = [
  {
    label: "Outstation",
    value: "bookRide",
  },

  { label: "Local", value: "package" },
  { label: "Airport pickup", value: "airportPickup" },
  { label: "Airport drop", value: "airportDrop" },
];

export const baseTripType = [
  { label: "Select", value: "" },
  {
    label: "Outstation",
    value: "outstation",
  },

  { label: "Hourly rental", value: "hourlyRental" },
  { label: "Local", value: "local" },
];
export const enquiryVehicleType = [
  {
    label: "SUV",
    value: 3,
  },
  {
    label: "Sedan",
    value: 2,
  },
];
export const geofenceType = [
  { label: "Select", value: "" },
  // {
  //   label: "Outstation",
  //   value: "outstation",
  // },
  {
    label: "Local",
    value: "local",
  },
  {
    label: "Outstation",
    value: "outstation",
  },
  {
    label: "Fixed route",
    value: "fixed route",
  },
  {
    label: "Inter state",
    value: "inter state",
  },
];
export const SurgeTripType = [
  {
    label: "Local",
    value: "local",
  },
  {
    label: "Fixed route",
    value: "fixed route",
  },
  {
    label: "Outstation",
    value: "outstation",
  },
];
export const hotRouteOptions = [
  { label: "All", value: "all" },
  { label: "Forward", value: "forward" },
  { label: "Reverse", value: "reverse" },
];

export const tripTypes = [
  { label: "All", value: "all" },
  { label: "A2C", value: "a2c" },
  { label: "C2A", value: "c2a" },
];
export const pricingTypes = [
  { label: "Regular", value: "regular" },
  { label: "Hotspot", value: "hotspot" },
  { label: "Hotroute", value: "hotroute" },
  { label: "Time-based pricing", value: "timebased" },
];
export const vehicleTypeOptions = [
  { label: "Select All", value: "all" },
  { label: "Hatchback", value: "hatchback" },
  { label: "Sedan", value: "sedan" },
  { label: "SUV", value: "suv" },
];

export const accoutType = [
  { label: "Current", value: "Current" },
  { label: "Savings", value: "Savings" },
];
export const hotRoutes = [
  { label: "Local", value: "LOCAL" },
  { label: "outstation", value: "OUTSTATION" },
];

export const userType = [
  { label: "Aggregator", value: "AGGREGATOR" },
  { label: "Operator", value: "OPERATOR" },
  { label: "Self", value: "SELF" },
];

export const operatingType = [
  // { label: "RADIUS", value: "RADIUS" },
  { label: "Operating area", value: "OPERATING AREA" },
];
export const geofencelist = [
  // { label: "RADIUS", value: "RADIUS" },
  { label: "POLYGON", value: "POLYGON" },
];
export const OperatingAreaFor = [
  { label: "TAXIDA", value: "TAXIDA" },
  { label: "OPERATOR", value: "OPERATOR" },
];

export const OperatingAreaType = [
  { label: "STATE", value: "STATE" },
  { label: "CITY", value: "CITY" },
  { label: "RAILWAY STATION", value: "RAILWAY STATION" },
  { label: "BUS STAND", value: "BUS STAND" },
  { label: "HOTELS", value: "HOTELS" },
  { label: "OTHER", value: "OTHER" },
];
export const boundaryType = [
  { label: "Select", value: "" },
  {
    label: "Draw",
    value: "draw",
  },
  {
    label: "Select state",
    value: "select",
  },
];
export const outstationType = [
  {
    label: "Pickup",
    value: "pickup",
  },
  {
    label: "Drop",
    value: "dropoff",
  },
  {
    label: "Pickup and Drop",
    value: "both",
  },
  {
    label: "Pickup or Drop",
    value: "any",
  },
];

export const restrictionBasedOnzone = [
  {
    label: "select",
    value: "",
  },
  {
    label: "Pickup",
    value: "pickup",
  },
  {
    label: "Drop",
    value: "drop",
  },
  {
    label: "Either pickup or drop",
    value: "either pickup or drop",
  },
];

export const minMmNotice = [
  { label: "Select", value: "" },
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
  { label: "13", value: 13 },
  { label: "14", value: 14 },
  { label: "15", value: 15 },
  { label: "16", value: 16 },
  { label: "17", value: 17 },
  { label: "18", value: 18 },
  { label: "19", value: 19 },
  { label: "20", value: 20 },
  { label: "21", value: 21 },
  { label: "22", value: 22 },
  { label: "23", value: 23 },
  { label: "24", value: 24 },
  { label: "25", value: 25 },
  { label: "26", value: 26 },
  { label: "27", value: 27 },
  { label: "28", value: 28 },
  { label: "29", value: 29 },
  { label: "30", value: 30 },
  { label: "31", value: 31 },
  { label: "32", value: 32 },
  { label: "33", value: 33 },
  { label: "34", value: 34 },
  { label: "35", value: 35 },
  { label: "36", value: 36 },
  { label: "37", value: 37 },
  { label: "38", value: 38 },
  { label: "39", value: 39 },
  { label: "40", value: 40 },
  { label: "41", value: 41 },
  { label: "42", value: 42 },
  { label: "43", value: 43 },
  { label: "44", value: 44 },
  { label: "45", value: 45 },
  { label: "46", value: 46 },
  { label: "47", value: 47 },
  { label: "48", value: 48 },
  { label: "49", value: 49 },
  { label: "50", value: 50 },
  { label: "51", value: 51 },
  { label: "52", value: 52 },
  { label: "53", value: 53 },
  { label: "54", value: 54 },
  { label: "55", value: 55 },
  { label: "56", value: 56 },
  { label: "57", value: 57 },
  { label: "58", value: 58 },
  { label: "59", value: 59 },
];

export const minHhNotice = [
  { label: "Select", value: "" },
  { label: "0", value: "0" },
  { label: "1", value: 60 },
  { label: "2", value: 120 },
  { label: "3", value: 180 },
  { label: "4", value: 240 },
  { label: "5", value: 300 },
  { label: "6", value: 360 },
  { label: "7", value: 420 },
  { label: "8", value: 480 },
  { label: "9", value: 540 },
  { label: "10", value: 600 },
  { label: "11", value: 660 },
  { label: "12", value: 720 },
  { label: "13", value: 780 },
  { label: "14", value: 840 },
  { label: "15", value: 900 },
  { label: "16", value: 960 },
  { label: "17", value: 1020 },
  { label: "18", value: 1080 },
  { label: "19", value: 1140 },
  { label: "20", value: 1200 },
  { label: "21", value: 1260 },
  { label: "22", value: 1320 },
  { label: "23", value: 1380 },
  { label: "24", value: 1440 },
];

export const minMmNotify = [
  { label: "00", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
  { label: "13", value: 13 },
  { label: "14", value: 14 },
  { label: "15", value: 15 },
  { label: "16", value: 16 },
  { label: "17", value: 17 },
  { label: "18", value: 18 },
  { label: "19", value: 19 },
  { label: "20", value: 20 },
  { label: "21", value: 21 },
  { label: "22", value: 22 },
  { label: "23", value: 23 },
  { label: "24", value: 24 },
  { label: "25", value: 25 },
  { label: "26", value: 26 },
  { label: "27", value: 27 },
  { label: "28", value: 28 },
  { label: "29", value: 29 },
  { label: "30", value: 30 },
  { label: "31", value: 31 },
  { label: "32", value: 32 },
  { label: "33", value: 33 },
  { label: "34", value: 34 },
  { label: "35", value: 35 },
  { label: "36", value: 36 },
  { label: "37", value: 37 },
  { label: "38", value: 38 },
  { label: "39", value: 39 },
  { label: "40", value: 40 },
  { label: "41", value: 41 },
  { label: "42", value: 42 },
  { label: "43", value: 43 },
  { label: "44", value: 44 },
  { label: "45", value: 45 },
  { label: "46", value: 46 },
  { label: "47", value: 47 },
  { label: "48", value: 48 },
  { label: "49", value: 49 },
  { label: "50", value: 50 },
  { label: "51", value: 51 },
  { label: "52", value: 52 },
  { label: "53", value: 53 },
  { label: "54", value: 54 },
  { label: "55", value: 55 },
  { label: "56", value: 56 },
  { label: "57", value: 57 },
  { label: "58", value: 58 },
  { label: "59", value: 59 },
];

export const minHhNotify = [
  { label: "00", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
];

export const minNotice = [
  { label: "Select", value: "" },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hr", value: 60 },
  { label: "2 hrs", value: 120 },
  { label: "3 hrs", value: 180 },
  { label: "4 hrs", value: 240 },
  { label: "5 hrs", value: 300 },
  { label: "6 hrs", value: 360 },
  { label: "7 hrs", value: 420 },
  { label: "8 hrs", value: 480 },
  { label: "9 hrs", value: 540 },
  { label: "10 hrs", value: 600 },
  { label: "11 hrs", value: 660 },
  { label: "12 hrs", value: 720 },
  { label: "13 hrs", value: 780 },
  { label: "14 hrs", value: 840 },
  { label: "15 hrs", value: 900 },
  { label: "16 hrs", value: 960 },
  { label: "17 hrs", value: 1020 },
  { label: "18 hrs", value: 1080 },
  { label: "19 hrs", value: 1140 },
  { label: "20 hrs", value: 1200 },
  { label: "21 hrs", value: 1260 },
  { label: "22 hrs", value: 1320 },
  { label: "23 hrs", value: 1380 },
  { label: "24 hrs", value: 1440 },
];

export const minNoticeOndc = [
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hrs", value: 60 },
  { label: "2 hrs", value: 120 },
  { label: "3 hrs", value: 180 },
  { label: "4 hrs", value: 240 },
  { label: "5 hrs", value: 300 },
  { label: "6 hrs", value: 360 },
  { label: "7 hrs", value: 420 },
  { label: "8 hrs", value: 480 },
  { label: "9 hrs", value: 540 },
  { label: "10 hrs", value: 600 },
  { label: "11 hrs", value: 660 },
  { label: "12 hrs", value: 720 },
  { label: "13 hrs", value: 780 },
  { label: "14 hrs", value: 840 },
  { label: "15 hrs", value: 900 },
  { label: "16 hrs", value: 960 },
  { label: "17 hrs", value: 1020 },
  { label: "18 hrs", value: 1080 },
  { label: "19 hrs", value: 1140 },
  { label: "20 hrs", value: 1200 },
  { label: "21 hrs", value: 1260 },
  { label: "22 hrs", value: 1320 },
  { label: "23 hrs", value: 1380 },
  { label: "24 hrs", value: 1440 },
];

export const dayWindows = [
  { label: "Select", value: "" },
  { label: "7 days", value: 7 },
  { label: "15 days", value: 15 },
  { label: "30 days", value: 30 },
  { label: "60 days", value: 60 },
];

export const settlementTypes = [
  { label: "Select", value: "" },
  { label: "UPI", value: "upi" },
];
export const buyerFinderFees = [
  { label: "Select", value: "" },
  { label: "Flat", value: "flat" },
  { label: "Percentage", value: "percentage" },
];

export const tariff = [
  { label: "Select", value: "" },
  { label: "Subscription", value: "subscription" },
  { label: "Flat commission", value: "flat" },
  { label: "Percentage commission", value: "percentage" },
];

export const selectTypes = [
  { label: "Amount received from aggregator", value: "Receivable" },
  { label: "Penalty details", value: "Payable" },
];

export const etsVehicleType = [
  {
    label: "SUV",
    value: "SUV",
  },
  {
    label: "Sedan",
    value: "Sedan",
  },
];
export const etsEmployeeStatus = [
  {
    label: "To be onboard",
    value: "to be onboard",
  },
  {
    label: "On boarded",
    value: "onboarded",
  },
  {
    label: "Dropped",
    value: "dropped",
  },
  {
    label: "No-show",
    value: "no show",
  },
];
export const specialDayTripType = [
  {
    label: "Local",
    value: "local",
  },
  { label: "Outstation", value: "outstation" },
  { label: "Both", value: "both" },
];
export const sdAvailability = [
  { label: "Select", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];
export const AvailabilityDD = [
  { label: "Select", value: "" },
  { label: "Forward", value: "Forward" },
  { label: "Reverse", value: "Reverse" },
];
export const businessBookingAvailability = [
  { label: "Select", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];
export const GeofenceVehicleAvailability = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
export const flashValueType = [
  { label: "Select", value: "" },
  { label: "Percentage", value: "percentage" },
  { label: "Flat", value: "flat" },
];

export const sdValueType = [
  { label: "Percentage", value: "percentage" },
  { label: "Flat", value: "flat" },
];
export const dateDayRangeType = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
];

export const baseValueType = [
  { label: "Select", value: "" },
  { label: "Flat", value: "Flat" },
  { label: "Percentage", value: "Percentage" },
];
export const calcValueType = [
  { label: "Percentage", value: "percentage" },
  { label: "Flat", value: "flat" },
  { label: "Per km", value: "perKm" },
];
export const surgeValueType = [
  { label: "Percentage", value: "percentage" },
  { label: "Flat", value: "flat" },
  { label: "Per km", value: "per-km" },
];

export const surgeCalcType = [
  { label: "Increase ", value: "increase" },
  { label: "Decrease", value: "decrease" },
  // { label: "Increase by flat", value: "increase by flat" },
  // { label: "Decrease by flat", value: "decrease by flat" },
  // { label: "Increase by Per km", value: "increase by perKm" },
  // { label: "Decrease by Per km", value: "decrease by perKm" },
];
export const surgeCalcTypeLocal = [
  { label: "Increase by %", value: "increase by percentage" },
  { label: "Decrease by %", value: "decrease by percentage" },
  { label: "Increase by flat", value: "increase by flat" },
  { label: "Decrease by flat", value: "decrease by flat" },
];

export const cancellationType = [
  { label: "SUPER FLEXI", value: "super-flexi" },
];

export const cancellationPolicy = [
  { label: "Select", value: "" },
  { label: "FREE TILL DEPARTURE", value: "Free till departure" },
  {
    label: "FREE TILL 1 HOUR BEFORE DEPARTURE",
    value: "Free till 1 hour before departure",
  },
];
export const cancelPolicy = [
  { label: "Select", value: "" },
  { label: "FREE TILL DEPARTURE", value: "Free till departure" },
  {
    label: "FREE TILL 1 HOUR BEFORE TRAVEL TIME",
    value: "Free till 1 hour before travel time",
  },
];
export const driverCurrentStatus = [
  { label: "Select", value: "" },
  { label: "On trip", value: "On trip" },
  { label: "Empty", value: "Empty" },
  { label: "Trip assigned", value: "Trip assigned" },
];
export const sdCompute = [
  { label: "Increase", value: "increase" },
  { label: "Decrease", value: "decrease" },
];
export const trip = {
  oneway: "One way",
  round: "Round",
  both: "Both",
};

export const notifyHrs = [
  { label: "5 mins", value: 5 },
  { label: "10 mins", value: 10 },
  { label: "15 mins", value: 15 },
  { label: "20 mins", value: 20 },
  { label: "25 mins", value: 25 },
  { label: "30 mins", value: 30 },
  { label: "35 mins", value: 35 },
  { label: "40 mins", value: 40 },
  { label: "45 mins", value: 45 },
  { label: "50 mins", value: 50 },
  { label: "55 mins", value: 55 },
  { label: "1:00 hrs", value: 60 },
];

export const notifyHrsOut = [
  { label: "5 mins", value: 5 },
  { label: "10 mins", value: 10 },
  { label: "15 mins", value: 15 },
  { label: "20 mins", value: 20 },
  { label: "25 mins", value: 25 },
  { label: "30 mins", value: 30 },
  { label: "35 mins", value: 35 },
  { label: "40 mins", value: 40 },
  { label: "45 mins", value: 45 },
  { label: "50 mins", value: 50 },
  { label: "55 mins", value: 55 },
  { label: "1:00 hrs", value: 60 },
  { label: "1:05 hrs", value: 65 },
  { label: "1:10 hrs", value: 70 },
  { label: "1:15 hrs", value: 75 },
  { label: "1:20 hrs", value: 80 },
  { label: "1:25 hrs", value: 85 },
  { label: "1:30 hrs", value: 90 },
  { label: "1:35 hrs", value: 95 },
  { label: "1:40 hrs", value: 100 },
  { label: "1:45 hrs", value: 105 },
  { label: "1:50 hrs", value: 110 },
  { label: "1:55 hrs", value: 115 },
  { label: "2:00 hrs", value: 120 },
  { label: "2:05 hrs", value: 125 },
  { label: "2:10 hrs", value: 130 },
  { label: "2:15 hrs", value: 135 },
  { label: "2:20 hrs", value: 140 },
  { label: "2:25 hrs", value: 145 },
  { label: "2:30 hrs", value: 150 },
  { label: "2:35 hrs", value: 155 },
  { label: "2:40 hrs", value: 160 },
  { label: "2:45 hrs", value: 165 },
  { label: "2:50 hrs", value: 170 },
  { label: "2:55 hrs", value: 175 },
  { label: "3:00 hrs", value: 180 },
];

export const bitHrs = [
  { label: "15 mins", value: 15 },
  { label: "30 mins", value: 30 },
  { label: "45 mins", value: 45 },
  { label: "1:00 hrs", value: 60 },
  { label: "1:15 hrs", value: 75 },
  { label: "1:30 hrs", value: 90 },
  { label: "1:45 hrs", value: 105 },
  { label: "2:00 hrs", value: 120 },
  { label: "2:15 hrs", value: 135 },
  { label: "2:30 hrs", value: 150 },
  { label: "2:45 hrs", value: 165 },
  { label: "3:00 hrs", value: 180 },
  { label: "3:15 hrs", value: 195 },
  { label: "3:30 hrs", value: 210 },
  { label: "3:45 hrs", value: 225 },
  { label: "4:00 hrs", value: 240 },
  { label: "4:15 hrs", value: 255 },
  { label: "4:30 hrs", value: 270 },
  { label: "4:45 hrs", value: 285 },
  { label: "5:00 hrs", value: 300 },
  { label: "5:15 hrs", value: 315 },
  { label: "5:30 hrs", value: 330 },
  { label: "5:45 hrs", value: 345 },
  { label: "6:00 hrs", value: 360 },
  { label: "6:15 hrs", value: 375 },
  { label: "6:30 hrs", value: 390 },
  { label: "6:45 hrs", value: 405 },
  { label: "7:00 hrs", value: 420 },
  { label: "7:15 hrs", value: 435 },
  { label: "7:30 hrs", value: 450 },
  { label: "7:45 hrs", value: 465 },
  { label: "8:00 hrs", value: 480 },
  { label: "8:15 hrs", value: 495 },
  { label: "8:30 hrs", value: 510 },
  { label: "8:45 hrs", value: 525 },
  { label: "9:00 hrs", value: 540 },
  { label: "9:15 hrs", value: 555 },
  { label: "9:30 hrs", value: 570 },
  { label: "9:45 hrs", value: 585 },
  { label: "10:00 hrs", value: 600 },
  { label: "10:15 hrs", value: 615 },
  { label: "10:30 hrs", value: 630 },
  { label: "10:45 hrs", value: 645 },
  { label: "11:00 hrs", value: 660 },
  { label: "11:15 hrs", value: 675 },
  { label: "11:30 hrs", value: 690 },
  { label: "11:45 hrs", value: 705 },
  { label: "12:00 hrs", value: 720 },
  { label: "12:15 hrs", value: 735 },
  { label: "12:30 hrs", value: 750 },
  { label: "12:45 hrs", value: 765 },
  { label: "13:00 hrs", value: 780 },
  { label: "13:15 hrs", value: 795 },
  { label: "13:30 hrs", value: 810 },
  { label: "13:45 hrs", value: 825 },
  { label: "14:00 hrs", value: 840 },
  { label: "14:15 hrs", value: 855 },
  { label: "14:30 hrs", value: 870 },
  { label: "14:45 hrs", value: 885 },
  { label: "15:00 hrs", value: 900 },
  { label: "15:15 hrs", value: 915 },
  { label: "15:30 hrs", value: 930 },
  { label: "15:45 hrs", value: 945 },
  { label: "16:00 hrs", value: 960 },
  { label: "16:15 hrs", value: 975 },
  { label: "16:30 hrs", value: 990 },
  { label: "16:45 hrs", value: 1005 },
  { label: "17:00 hrs", value: 1020 },
  { label: "17:15 hrs", value: 1035 },
  { label: "17:30 hrs", value: 1050 },
  { label: "17:45 hrs", value: 1065 },
  { label: "18:00 hrs", value: 1080 },
  { label: "18:15 hrs", value: 1095 },
  { label: "18:30 hrs", value: 1110 },
  { label: "18:45 hrs", value: 1125 },
  { label: "19:00 hrs", value: 1140 },
  { label: "19:15 hrs", value: 1155 },
  { label: "19:30 hrs", value: 1170 },
  { label: "19:45 hrs", value: 1185 },
  { label: "20:00 hrs", value: 1200 },
  { label: "20:15 hrs", value: 1215 },
  { label: "20:30 hrs", value: 1230 },
  { label: "20:45 hrs", value: 1245 },
  { label: "21:00 hrs", value: 1260 },
  { label: "21:15 hrs", value: 1275 },
  { label: "21:30 hrs", value: 1290 },
  { label: "21:45 hrs", value: 1305 },
  { label: "22:00 hrs", value: 1320 },
  { label: "22:15 hrs", value: 1335 },
  { label: "22:30 hrs", value: 1350 },
  { label: "22:45 hrs", value: 1365 },
  { label: "23:00 hrs", value: 1380 },
  { label: "23:15 hrs", value: 1395 },
  { label: "23:30 hrs", value: 1410 },
  { label: "23:45 hrs", value: 1425 },
  { label: "24:00 hrs", value: 1440 },
];

export const waitHrs = [
  { label: "1 min", value: 1 },
  { label: "2 Mins", value: 2 },
  { label: "3 Mins", value: 3 },
  { label: "4 Mins", value: 4 },
  { label: "5 Mins", value: 5 },
  { label: "6 Mins", value: 6 },
  { label: "7 Mins", value: 7 },
  { label: "8 Mins", value: 8 },
  { label: "9 Mins", value: 9 },
  { label: "10 Mins", value: 10 },
  { label: "11 Mins", value: 11 },
  { label: "12 Mins", value: 12 },
  { label: "13 Mins", value: 13 },
  { label: "14 Mins", value: 14 },
  { label: "0:15 hr", value: 15 },
  { label: "0:30 hr", value: 30 },
  { label: "0:45 hr", value: 45 },
  { label: "1:00 hr", value: 60 },
  { label: "1:15 hrs", value: 75 },
  { label: "1:30 hrs", value: 90 },
  { label: "1:45 hrs", value: 105 },
  { label: "2:00 hrs", value: 120 },
  { label: "2:15 hrs", value: 135 },
  { label: "2:30 hrs", value: 150 },
  { label: "2:45 hrs", value: 165 },
  { label: "3:00 hrs", value: 180 },
  { label: "3:15 hrs", value: 195 },
  { label: "3:30 hrs", value: 210 },
  { label: "3:45 hrs", value: 225 },
  { label: "4:00 hrs", value: 240 },
  { label: "4:15 hrs", value: 255 },
  { label: "4:30 hrs", value: 270 },
  { label: "4:45 hrs", value: 285 },
  { label: "5:00 hrs", value: 300 },
];

export const freeWaitHrs = [
  { label: "20 Mins", value: 20 },
  { label: "25 Mins", value: 25 },
  { label: "30 Mins", value: 30 },
  { label: "35 Mins", value: 35 },
  { label: "40 Mins", value: 40 },
  { label: "45 Mins", value: 45 },
  { label: "50 Mins", value: 50 },
  { label: "55 Mins", value: 55 },
  { label: "1:00 hr", value: 60 },
  { label: "1:15 hrs", value: 75 },
  { label: "1:30 hrs", value: 90 },
  { label: "1:45 hrs", value: 105 },
  { label: "2:00 hrs", value: 120 },
  { label: "2:15 hrs", value: 135 },
  { label: "2:30 hrs", value: 150 },
  { label: "2:45 hrs", value: 165 },
  { label: "3:00 hrs", value: 180 },
];

export const surgeMethod = [
  { label: "Increase", value: "increase" },
  { label: "Decrease", value: "decrease" },
];

export const driverVehicleTypes = [
  { label: "Hatchback", value: 1 },
  { label: "Sedan", value: 2 },
  { label: "Economy SUV", value: 3 },
  { label: "Premium SUV", value: 4 },
];

export const pricingVehicleTypes = [
  { label: "Hatchback", value: 1 },
  { label: "Sedan", value: 2 },
  { label: "SUV", value: 3 },
];

export const pricingType = [
  { label: "Unit based pricing", value: "unit" },
  // { label: "Slab based pricing", value: "slab" },
];

export const recordStatus = {
  paid: "Paid",
  unpaid: "Unpaid",
  partiallyPaid: "Partial",
};

export const permitList = [
  { label: "All India", value: "All India" },
  { label: "State", value: "State" },
];

export const rolePermissions = [
  {
    user: "Admin",
    roleId: 1,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "delete", "assign", "broadcast"],
      users: ["create", "edit", "delete"],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: ["create", "edit", "delete"],
      operatorGroup: ["create", "edit", "delete"],
      fare: ["create", "edit", "delete"],
      commissions: ["create", "edit", "delete"],
      vehicleTypes: ["create", "edit", "delete"],
      taxidaQuotes: ["create", "edit", "delete"],
      statements: ["create", "edit"],
      invoice: ["create", "edit"],
      driverAlert: ["edit", "delete"],
      promoCodes: ["create", "edit", "delete"],
      operatingArea: ["create", "edit", "delete"],
    },
  },
  {
    user: "Sub-admin",
    roleId: 2,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],
      users: ["create"],
      drivers: ["create"],
      driverGroup: ["create"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Controller",
    roleId: 3,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],

      drivers: [],
      users: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Affiliate agent",
    roleId: 4,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Business-User",
    roleId: 6,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Affiliate-driver",
    roleId: 7,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Driver manager",
    roleId: 9,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit"],
      driverGroup: ["create", "edit"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Operators",
    roleId: 10,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
];

export const operatingDistricts = [
  { label: "Ariyalur", value: "Ariyalur" },
  { label: "Chengalpattu", value: "Chengalpattu" },
  { label: "Chennai", value: "Chennai" },
  { label: "Cuddalore", value: "Cuddalore" },
  { label: "Dharmapuri", value: "Dharmapuri" },
  { label: "Dindigul", value: "Dindigul" },
  { label: "Erode", value: "Erode" },
  { label: "Kallakurichi", value: "Kallakurichi" },
  { label: "Kanchipuram", value: "Kanchipuram" },
  { label: "Kanyakumari", value: "Kanyakumari" },
  { label: "Karur", value: "Karur" },
  { label: "Krishnagiri", value: "Krishnagiri" },
  { label: "Madurai", value: "Madurai" },
  { label: "Mayiladuthurai", value: "Mayiladuthurai" },
  { label: "Nagapattinam", value: "Nagapattinam" },
  { label: "Namakkal", value: "Namakkal" },
  { label: "Nilgiris", value: "Nilgiris" },
  { label: "Perambalur", value: "Perambalur" },
  { label: "Pudukkottai", value: "Pudukkottai" },
  { label: "Ramanathapuram", value: "Ramanathapuram" },
  { label: "Ranipet", value: "Ranipet" },
  { label: "Salem", value: "Salem" },
  { label: "Sivagangai", value: "Sivagangai" },
  { label: "Tenkasi", value: "Tenkasi" },
  { label: "Thanjavur", value: "Thanjavur" },
  { label: "Theni", value: "Theni" },
  { label: "Thoothukudi", value: "Thoothukudi" },
  { label: "Tiruchirappalli", value: "Tiruchirappalli" },
  { label: "Tirunelveli", value: "Tirunelveli" },
  { label: "Tirupattur", value: "Tirupattur" },
  { label: "Tiruppur", value: "Tiruppur" },
  { label: "Tiruvallur", value: "Tiruvallur" },
  { label: "Tiruvannamalai", value: "Tiruvannamalai" },
  { label: "Tiruvarur", value: "Tiruvarur" },
  { label: "Vellore", value: "Vellore" },
  { label: "Viluppuram", value: "Viluppuram" },
  { label: "Virudhunagar", value: "Virudhunagar" },
];

export const auctoBidDuration = [
  { label: "30mins", value: 30 },
  { label: "1hr", value: 60 },
  { label: "1hr 30mins", value: 90 },
  { label: "2hrs", value: 120 },
  { label: "2hrs 30mins", value: 150 },
  { label: "3hrs", value: 180 },
  { label: "3hrs 30mins", value: 210 },
  { label: "4hrs", value: 240 },
  { label: "4hrs 30mins", value: 270 },
  { label: "5hrs", value: 300 },
  { label: "5hrs 30mins", value: 330 },
  { label: "6hrs", value: 360 },
  { label: "6hrs 30mins", value: 390 },
  { label: "7hrs", value: 420 },
  { label: "7hrs 30mins", value: 450 },
  { label: "8hrs", value: 480 },
  { label: "8hrs 30mins", value: 510 },
  { label: "9hrs", value: 540 },
  { label: "9hrs 30mins", value: 570 },
  { label: "10hrs", value: 600 },
  { label: "10hrs 30mins", value: 630 },
  { label: "11hrs", value: 660 },
  { label: "11hrs 30mins", value: 690 },
  { label: "12hrs", value: 720 },
];

export const auctoConfigTime = [
  { label: "Bid expiry", value: "bidExpiry" },
  { label: "Min time", value: "minTime" },
];

export const cityList = [
  { value: "Chennai", label: "Chennai" },
  { value: "Bengaluru", label: "Bengaluru" },
];

export const stateList = [
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CG", label: "Chandigarh" },
  { value: "CH", label: "Chhattisgarh" },
  { value: "DN", label: "Dadra and Nagar Haveli" },
  { value: "DD", label: "Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PY", label: "Puducherry" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
];

export const hourNkm = [
  { label: "3hr-30Km", value: "3hr-30Km" },
  { label: "4hr-40km", value: "4hr-40km" },
  { label: "5hr-50km", value: "5hr-50km" },
  { label: "6hr-60km", value: "6hr-60km" },
  { label: "7hr-70km", value: "7hr-70km" },
  { label: "8hr-80km", value: "8hr-80km" },
  { label: "9hr-90km", value: "9hr-90km" },
  { label: "10hr-100km", value: "10hr-100km" },
  { label: "11hr-110km", value: "11hr-110km" },
  { label: "12hr-120km", value: "12hr-120km" },
];

export const minNoticePeriod = [
  { label: "00:15", value: 15 },
  { label: "00:30", value: 30 },
  { label: "00:45", value: 45 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "04:00", value: 240 },
  { label: "05:00", value: 300 },
  { label: "06:00", value: 360 },
  { label: "07:00", value: 420 },
  { label: "08:00", value: 480 },
  { label: "09:00", value: 540 },
  { label: "10:00", value: 600 },
  { label: "11:00", value: 660 },
  { label: "12:00", value: 720 },
  { label: "13:00", value: 780 },
  { label: "14:00", value: 840 },
  { label: "15:00", value: 900 },
  { label: "16:00", value: 960 },
  { label: "17:00", value: 1020 },
  { label: "18:00", value: 1080 },
  { label: "19:00", value: 1140 },
  { label: "20:00", value: 1200 },
  { label: "21:00", value: 1260 },
  { label: "22:00", value: 1320 },
  { label: "23:00", value: 1380 },
  { label: "24:00", value: 1440 },
];
